export default __webpack_public_path__ + "assets/434fffdb6a24e22874deb7f98428aade/mosaic.svg";